<template>
    <fragment>
        <div
            v-for="(tag, index) in tags"
            :key="index"
            class="flex mx-2 leading-5 bg-gray-400 rounded-full"
        >
            <button
                @click="updateValue(tag.title)"
                class="flex inline-flex items-center justify-center w-full px-6 py-2 text-base font-medium leading-5 rounded-full focus:outline-none "
                :class="{
                    'bg-gray-400  text-gray-700': !tag.isChecked,
                    'bg-blue-600 text-white': tag.isChecked
                }"
            >
                {{ tag.title }}
            </button>
        </div>
    </fragment>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            required: true
        },
        values: {
            type: Array,
            required: true
        }
    },
    methods: {
        updateValue(title) {
            this.$emit("input", title);
        }
    },
    computed: {}
};
</script>

<style></style>
